/**
 * Generates a chat name based on the provided list of names and an optional title.
 * If the title is provided, it will be used as the chat name.
 *
 * @param names - An array of strings representing the names of the chat participants.
 * @param title - An optional string representing the title of the chat.
 * @returns A string representing the generated chat name.
 */

export const getChatTitle = (names: string[], title?: string): string => {
  if (title) return title;
  if (names.length === 0) return "Chat";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  const lastItem = names.pop();
  return `${names.join(", ")}, and ${lastItem}`;
};
